/* eslint-disable no-console */
// Web-safe mock for @react-native-firebase/perf
// Provides Firebase performance monitoring functionality for web

const mockPerf = () => ({
  // Create HTTP metric for tracking network requests
  newHttpMetric: (url, method) => ({
    start: () => {
      console.log('Firebase Perf: Started HTTP metric', method, url);
    },
    stop: () => {
      console.log('Firebase Perf: Stopped HTTP metric', method, url);
    },
    setHttpResponseCode: code => {
      console.log('Firebase Perf: Set response code', code);
    },
    setResponsePayloadSize: size => {
      console.log('Firebase Perf: Set payload size', size);
    },
    putAttribute: (key, value) => {
      console.log('Firebase Perf: Set attribute', key, value);
    },
  }),

  // Enable/disable performance collection
  setPerformanceCollectionEnabled: enabled => {
    console.log('Firebase Perf: Set performance collection enabled:', enabled);
  },

  // Create trace for custom performance monitoring
  newTrace: name => ({
    start: () => {
      console.log('Firebase Perf: Started trace', name);
    },
    stop: () => {
      console.log('Firebase Perf: Stopped trace', name);
    },
    putAttribute: (key, value) => {
      console.log('Firebase Perf: Trace attribute', key, value);
    },
  }),
});

export default mockPerf;
